import { createStore } from 'vuex';
import globalConfig from 'shared/store/globalConfig';
import uiSettings from 'shared/store/uiSettings';

export default createStore({
  modules: {
    globalConfig,
    uiSettings,
  },
});
